// WMPS-4245: This AccountType should be replaced with InventoryItemType (and the other refs to it)
export enum AccountType {
  BANK = "bank-accounts",
  RETIREMENT_ANNUITY = "retirement-accounts-annuities",
  INVESTMENT = "investment",
  REAL_ESTATE = "real-estate",
  MORTGAGE = "mortgage",
  LIABILITIES = "liabilities",
  TRUST = "trust",
}
